module.exports = __webpack_public_path__ + "img/anewitem-machinery.25495cac.svg";